import { Box, Button } from '@mui/material'
import AuthTemplate from 'components/templates/AuthTemplate'

const NotFound: React.FC = () => {
  return (
    <AuthTemplate>
      <Box textAlign="center">
        <h1>404</h1>
        <h2 style={{ marginBottom: 40 }}>Page not found</h2>
        <Button href="/login" className="link">
          Go to Log In page
        </Button>
      </Box>
    </AuthTemplate>
  )
}

export default NotFound
